<div class="dialog-padding">
  <h1 mat-dialog-title>Select Cancellation Reason</h1>
  <div mat-modal-content [formGroup]="cancellationForm">
    <div *ngIf="!shouldShowCancellationReasonsLoadingSpinner && (!cancellationReasons || cancellationReasons.length == 0)">
      <h1>No Cancellation Reasons</h1>
    </div>
    <mat-spinner
      #cancellationReasonsLoadingSpinner
      class="cancellation-reasons-loading-spinner"
      *ngIf="shouldShowCancellationReasonsLoadingSpinner"
    ></mat-spinner>

    <mat-radio-group formControlName="cancellationReason">
      <mat-list>
        <ng-container *ngFor="let cancellationReason of cancellationReasons">
          <mat-list-item *ngIf="isCancellationReasonEnabled(cancellationReason)">
            <mat-radio-button
              id="cancelReservationDialog-button-{{ cancellationReason.name | camelCase }}"
              [value]="cancellationReason"
              matListItemLine
            >
              {{ cancellationReason.name }}
            </mat-radio-button>
          </mat-list-item>
        </ng-container>
      </mat-list>
    </mat-radio-group>

    <div class="cancellation-reason-details" *ngIf="shouldShowCancellationReasonDetails()">
      <p>Please provide details for the cancellation:</p>
      <mat-form-field appearance="outline">
        <mat-label>Add details here</mat-label>
        <textarea
          id="cancelReservationDialog-textarea-addDetailsHere"
          matInput
          class="form-control"
          formControlName="cancellationReasonDetails"
          autocomplete="off"
          rows="5"
        >
        </textarea>
      </mat-form-field>
      <mat-error *ngIf="cancellationForm.controls.cancellationReasonDetails.dirty && cancellationForm.controls.cancellationReasonDetails.invalid" class="error">{{ detailsErrorText }}</mat-error>
      <mat-hint *ngIf="cancellationForm.controls.cancellationReasonDetails.value">{{ cancellationForm.controls.cancellationReasonDetails.value.length }} / 1000</mat-hint>
    </div>
  </div>
  <div mat-dialog-actions align="end">
    <button type="button" mat-button (click)="closeModal()">Close</button>
    <button
      id="cancelReservationDialog-button-cancelReservation"
      type="button"
      mat-raised-button
      color="warn"
      (click)="cancelRide()"
      [disabled]="cancellationForm.invalid"
    >
      Cancel {{ rideType }}
    </button>
    <button
      id="cancelReservationDialog-button-cancelAndCreateRecovery"
      *ngIf="shouldShowCreateRecovery"
      type="button"
      mat-raised-button
      color="primary"
      (click)="cancelRideWithRecovery()"
      [disabled]="cancellationForm.invalid"
    >
      Cancel and Create Recovery
    </button>
  </div>
</div>
